import React from "react";
import IbridoWidget from "./Ibrido";
import CassaPrivatizzataWidget from "./CassaPrivatizzata";
import MinimaliMassimaliWidget from "./MinimaliMassimali";
import LiberaProfessioneWidget from "./LiberaProfessione";
import LiberaProfessioneEnpalsWidget from "./LiberaProfessioneEnpals";

//------------
// ROUTER contributi prev e ass
const ContributiPrevidenzialiRouter = ({
  fatturato,
  contributiCase,
  ibrido,
  contributiTotali,
  setContributiTotali,
  riduzioneContributi,
  redditoPrevidenziale,
  isFullTime,
  gestionePrevidenziale,
  cassaCoeff,
  setCassaCoeff,
  parameters,
  setIbridoCase,
}) => {
  return (
    <>
      {ibrido === "1" ? (
        <IbridoWidget
          fatturato={fatturato}
          contributiTotali={contributiTotali}
          setContributiTotali={setContributiTotali}
          riduzioneContributi={riduzioneContributi}
          redditoPrevidenziale={redditoPrevidenziale}
          isFullTime={isFullTime}
          setIbridoCase={setIbridoCase}
          parameters={parameters}
        />
      ) : gestionePrevidenziale === "4" ? (
        <CassaPrivatizzataWidget
          redditoPrevidenziale={redditoPrevidenziale}
          contributiTotali={contributiTotali}
          setContributiTotali={setContributiTotali}
          isFullTime={isFullTime}
          cassaCoeff={cassaCoeff}
          setCassaCoeff={setCassaCoeff}
          parameters={parameters}
        />
      ) : gestionePrevidenziale === "0" ||
        gestionePrevidenziale === "1" ||
        gestionePrevidenziale === "2" ? (
        <MinimaliMassimaliWidget
          fatturato={fatturato}
          contributiTotali={contributiTotali}
          setContributiTotali={setContributiTotali}
          riduzioneContributi={riduzioneContributi}
          redditoPrevidenziale={redditoPrevidenziale}
          isFullTime={isFullTime}
          parameters={parameters}
        />
      ) : gestionePrevidenziale === "3" &&
        parameters.eccezioneENPALS === "0" ? (
        <LiberaProfessioneWidget
          contributiTotali={contributiTotali}
          setContributiTotali={setContributiTotali}
          redditoPrevidenziale={redditoPrevidenziale}
          isFullTime={isFullTime}
        />
      ) : (
        <LiberaProfessioneEnpalsWidget
          contributiTotali={contributiTotali}
          setContributiTotali={setContributiTotali}
          redditoPrevidenziale={redditoPrevidenziale}
          isFullTime={isFullTime}
        />
      )}
    </>
  );
};
// -------------------------------------------
// -------------------------------------------
export default ContributiPrevidenzialiRouter;
